import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import donnaThumb from 'images/donna_thumb16.jpg';

export class CreatedByImage extends Field {
  static subqueriesForModel() {
    return { createdByUser: ['name', 'avatarUrl', 'initials'] };
  }

  get title() {
    return 'Created by image';
  }

  exampleContents(): FieldContentsData {
    return { avatar: { src: donnaThumb, name: 'User name', initials: 'UN' } };
  }

  contentsForRecord(record): FieldContentsData {
    const { createdByUser } = record;
    if (createdByUser) {
      return {
        avatar: {
          src: createdByUser.avatarUrl,
          name: createdByUser.name,
          initials: createdByUser.initials,
        },
      };
    }

    return {};
  }
}
